module.exports = flarum.core.compat['models/Discussion'];